import { emailRegex } from 'noddi-util';
import { z } from 'zod';

// The preview API rejects more plates than this.
export const signupLicensePlateLimit = 10;

type Translations = {
  thisFieldIsRequired: string;
  thisFieldMustBeAtLeast2CharactersLong: string;
  mustProvideAValidEmailAddress: string;
};

export const verifiedSignupFormSchema = (translations: Translations) =>
  z.object({
    firstName: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .min(2, translations.thisFieldMustBeAtLeast2CharactersLong),
    surname: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .min(2, translations.thisFieldMustBeAtLeast2CharactersLong),
    email: z
      .string()
      .min(1, translations.thisFieldIsRequired)
      .regex(emailRegex, translations.mustProvideAValidEmailAddress)
      .pipe(z.email(translations.mustProvideAValidEmailAddress)),
    licensePlateNumbers: z.array(z.string()).max(signupLicensePlateLimit)
  });

export type VerifiedSignupFormValues = z.input<ReturnType<typeof verifiedSignupFormSchema>>;
